import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Level, Pallet } from '../stock-levels-model/stock-levels-modal.component';
import { CrateType } from 'src/models/Crate';
import { CratesDataSourceService } from 'src/app/core/data-sources/crates-data-source.service';
import { GroundGroupPosition } from 'src/app/core/data-sources/ground-position-group-data-source.service';
import { MapPalletDetailsComponent } from 'src/app/shared/map-pallet-details/map-pallet-details.component';

interface MapPositionDetailsModalDataInterface {
  alias?: string,
  position?: string;
  selectedTabIndex?: number;
  scrollTo?: string;
  type?: 'column' | 'row';
  rfId?: string;
}

@Component({
  selector: 'app-map-position-details-modal',
  templateUrl: './map-position-details-modal.component.html',
  styleUrls: ['./map-position-details-modal.component.scss']
})
export class MapPositionDetailsModalComponent implements OnInit {
  @ViewChild(MapPalletDetailsComponent) palletDetailsComponent: MapPalletDetailsComponent;
  title = '';
  isPallet = false;
  isPosition = true;
  palletDetails;
  pallet: Pallet;
  itemDetails;
  showEditLevelComponent = false;
  levelToEdit: Level;
  positionToEdit: GroundGroupPosition;

  constructor(
    public dialogRef: MatDialogRef<MapPositionDetailsModalComponent>,
    private crateService: CratesDataSourceService,
    @Inject(MAT_DIALOG_DATA) public data: MapPositionDetailsModalDataInterface
  ) { }

  ngOnInit(): void {
    this.setTitle(this.data.alias, this.data.position);
  }

  async onChangeToPallet(pallet: Pallet, page: number = 0) {
    this.itemDetails = await this.crateService.getCrateById(pallet.id).then((r: any) => {
      r.invoice = r.crate.invoices[0];
      return r;
    });
    this.pallet = pallet;
    this.palletDetails = {
      item: pallet,
      itemDetails: this.itemDetails,
      isExit: pallet.type === CrateType.REMAINS,
      page
    };
    this.isPallet = true;
    this.isPosition = false;
    this.setTitle(null, null);
  }

  goBackToMap() {
    if (this.showEditLevelComponent) {
      this.showEditLevelComponent = false;
      this.isPallet = false;
      this.isPosition = true;
      this.data.selectedTabIndex = 0;
      this.setTitle(this.data.alias, this.data.position);
      return;
    }
    if (this.isPallet && this.palletDetailsComponent?.isNavigatedPallet) {
      this.palletDetailsComponent.goBackToPreviousPallet();
      return;
    }
    this.isPosition = true;
    this.isPallet = false;
    this.data.selectedTabIndex = 1;
    this.data.scrollTo = this.pallet.tagRfid;
    this.setTitle(this.data.alias, this.data.position);
  }

  close() {
    this.dialogRef.close();
  }

  setTitle(alias?: string, name?: string) {
    if (this.isPallet) {
      this.title = 'Dados Do Pallet';
      return
    }
    switch (this.data.type) {
      case 'column':
        this.title = `Coluna ${name}`;
        break;
      case 'row':
        this.title = `Linha ${name}`;
        break;
      default:
        this.title = alias ?? '---';
        break;
    }
  }

  onRelocateClicked($event) {
    this.dialogRef.close({
      openRelocateSidenav: true,
      crate: $event.crate
    });
  }

  onMapInventoryClicked($event) {
    this.dialogRef.close({
      openInventorySidenav: true,
      position: $event
    });
  }

  async onListPalletInventoryClicked(pallet: Pallet) {
    this.itemDetails = await this.crateService.getCrateById(pallet.id).then((r: any) => {
      r.invoice = r.crate.invoices[0];
      return r;
    });
    this.dialogRef.close({
      crate: this.itemDetails.crate,
      openPalletInventorySidenav: true,
      position: this.itemDetails.position
    });
  }

  onListPalletRelocateClicked(pallet: Pallet) {
    this.dialogRef.close({
      openRelocateSidenav: true,
      crate: pallet
    });
  }
  
  onPalletInventoryClicked($event) {
    this.dialogRef.close({
      crate: $event,
      openPalletInventorySidenav: true,
      position: this.itemDetails.position
    });
  }

  onChangeToEditLevel(obj) {
    this.levelToEdit = obj.level;
    this.positionToEdit = obj.position;
    this.showEditLevelComponent = true;
    this.isPallet = false;
    this.isPosition = false;
    this.title = 'Editar Nível';
  }

}
